"use strict";
exports.__esModule = true;
var react_emotion_1 = require("react-emotion");
exports["default"] = react_emotion_1["default"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ29tcG9uZW50L3RoZW1lL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsK0NBQW1FO0FBR25FLHFCQUFlLDBCQUE0QyxDQUFBIn0=